import it from "./it";

export default {
  it,
};
